<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="content_wrap container">
      <div class="content_title">
        <titleConfig
          v-if="type == 1"
          :title="langSet == 'cn' ? '会议详情' : 'Conference Details'"
          :type="2"
        ></titleConfig>
        <titleConfig
          v-if="type == 3"
          :title="langSet == 'cn' ? '活动详情' : 'Event Details'"
          :type="2"
        ></titleConfig>
      </div>
      <div v-loading="loading">
        <div class="content-top flex flex_items_center">
          <template v-if="type == 1">
            <el-image
              v-if="details.img"
              class="img-wrap"
              :src="details.img"
              :fit="'cover'"
            ></el-image>
            <img class="img-wrap" v-else src="../../assets/kv.jpg" alt="" />
          </template>
          <template v-if="type == 3">
            <div
              class="collect flex flex_items_center flex_content_center"
              :class="{ active: details.is_collect == 1 }"
              @click="toCollect"
            >
              <span v-if="details.is_collect == 0"
                >{{ langSet == "cn" ? "收藏" : "My Favorites" }} |</span
              >
              <span v-if="details.is_collect == 1"
                >{{ langSet == "cn" ? "已收藏" : "My Favorites" }} |</span
              >
              <img class="icon" src="../../assets/icon_h.png" />
            </div>
            <el-image
              v-if="details.thumb"
              class="img-wrap"
              :src="details.thumb"
              :fit="'cover'"
            ></el-image>
            <img class="img-wrap" v-else src="../../assets/kv.jpg" alt="" />
          </template>
          <div class="content-text">
            <div class="title">
              {{ langSet == "cn" ? details.title : details.en_title }}
            </div>
            <div>
              {{ langSet == "cn" ? "时间" : "Time" }}：{{ details.starttime }}
            </div>
            <div v-if="details.address || details.en_address">
              {{ langSet == "cn" ? "地点" : "Location" }}：{{
                langSet == "cn" ? details.address : details.en_address
              }}
            </div>
            <div class="button" @click="toLink" v-if="type == 1">
              {{ langSet == "cn" ? "立即报名" : "Register Now" }}
            </div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="title" v-if="type == 1">
            {{ langSet == "cn" ? "会议介绍" : "Introductions" }}
          </div>
          <div class="title" v-if="type == 3">
            {{ langSet == "cn" ? "活动介绍" : "Introductions" }}
          </div>
          <div
            v-html="langSet == 'cn' ? details.content : details.en_content"
          ></div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <bottom></bottom>
  </div>
</template>

<script>
import top from "@/components/top.vue";
import bottom from "@/components/bottom.vue";
import titleConfig from "@/components/title.vue";
import { offlineMeetDetail, activityDetail, collect } from "@/api/api";
import { sdkTime } from "../../sdk/useSdk";
export default {
  // 配置title和meta数据
  metaInfo() {
    return {
      title: this.metaData.name_cn,
      meta: [
        {
          name: "description",
          content: this.metaData.description,
        },
        {
          name: "keywords",
          content: this.metaData.keywords,
        },
      ],
    };
  },
  components: {
    top,
    bottom,
    titleConfig,
  },
  data() {
    return {
      loading: false,
      langSet: "",
      id: 0,
      type: 0,
      details: {},
      metaData: {},
      // 埋点
      timeKeeping: 0,
      interval: null,
    };
  },
  created() {},
  activated() {
    let menuArr = JSON.parse(localStorage.getItem("menuArr"));
    let path = this.$route.fullPath;
    this.metaData = this.findInNestedArray(
      menuArr,
      (item) => item.http_url_cn == path
    );
  },
  mounted() {
    this.langSet = this.$language;
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
    //25.9.16 获取详情 dxm
    this.getDetails(this.id);
    let interval = setInterval(() => {
      this.timeKeeping = this.timeKeeping + 1;
    }, 1000);
    this.interval = interval;
    window.addEventListener("beforeunload", this.stopTimeKeeping);
  },
  beforeDestroy() {
    this.stopTimeKeeping();
    window.removeEventListener("beforeunload", this.stopTimeKeeping);
  },
  methods: {
    findInNestedArray(arr, condition) {
      // 使用map遍历外层数组
      const result = arr
        .map((item) => {
          if (condition(item)) return item;

          // 处理嵌套数组
          if (Array.isArray(item.children)) {
            const nestedResult = this.findInNestedArray(
              item.children,
              condition
            );
            if (nestedResult) return nestedResult;
          }
          return null;
        })
        .find((item) => item !== null);

      return result || null;
    },
    async getDetails(id) {
      let data = {
        id,
      };
      this.loading = true;
      if (this.type == 1) {
        const res = await offlineMeetDetail(data);
        this.details = res.data;
        this.loading = false;
      } else if (this.type == 3) {
        const res = await activityDetail(data);
        this.details = res.data;
        this.loading = false;
      }
    },
    async toCollect() {
      let data = {
        type: 3,
        dataId: this.details.id,
        status: this.details.is_collect == 0 ? 1 : 0,
      };
      const res = await collect(data);
      if (res.code == 1) {
        this.$message.success(
          this.details.is_collect == 0 ? "收藏成功" : "取消收藏成功"
        );
        this.details.is_collect = this.details.is_collect == 0 ? 1 : 0;
      }
    },
    toLink() {
      if (this.details.web_url) {
        window.open(this.details.web_url, "_blank");
      } else {
        this.$message.warning(
          this.langSet == "cn"
            ? "暂无报名"
            : "No registration available at the moment"
        );
      }
    },
    stopTimeKeeping() {
      sdkTime("浏览会议活动", this.details.title, this.timeKeeping);
      clearInterval(this.interval);
    },
  },
};
</script>
<style lang="scss" scoped>
.content_wrap {
  padding: 80px 0;
  .content_title {
    margin-bottom: 30px;
  }
  .content-top {
    padding: 30px;
    background: #f9fafc;
    border-radius: 30px;
    margin-bottom: 30px;
    font-size: 15px;
    color: #757575;
    line-height: 21px;
    position: relative;
    .collect {
      position: absolute;
      top: 44px;
      right: 30px;
      width: 124px;
      height: 40px;
      color: #fff;
      font-size: 14px;
      cursor: pointer;
      background: #77a5e6;
      border-radius: 8px;
      &:hover {
        background: #1d2379;
      }
      .icon {
        width: 15px;
        height: 15px;
        margin-left: 7px;
      }
    }
    .active {
      background: #1d2379;
    }
    .img-wrap {
      width: 376px;
      height: 208px;
      margin-right: 20px;
      background: #ccc;
      border-radius: 20px;
    }
    .content-text {
      flex: 1;
      & > div {
        margin-bottom: 10px;
      }
      .title {
        width: 80%;
        font-weight: 500;
        font-size: 20px;
        color: #2c2c2e;
        line-height: 28px;
      }
      .button {
        width: 200px;
        height: 48px;
        color: #fff;
        font-size: 16px;
        cursor: pointer;
        text-align: center;
        line-height: 48px;
        background: #1d2379;
        border-radius: 24px;
        margin: 30px 0 0;
      }
    }
  }
  .content-bottom {
    padding: 30px;
    background: #f9fafc;
    border-radius: 30px;
    /deep/ p img {
      max-width: 100% !important;
      display: inline-block;
    }
    .title {
      font-weight: 500;
      font-size: 18px;
      color: #001a33;
      line-height: 25px;
      padding-bottom: 10px;
    }
  }
}
@media only screen and (max-width: 1280px) {
  .content_wrap .content-top .content-text .title {
    width: 70%;
  }
}
@media only screen and (max-width: 767px) {
  .content_wrap {
    padding: 0.58rem 0;
    .content-top {
      flex-wrap: wrap;
      padding: 0.29rem;
      font-size: 0.27rem;
      line-height: 0.38rem;
      margin-bottom: 0.38rem;
      border-radius: 10px;
      .img-wrap {
        width: 100%;
        height: 100%;
        margin-right: 0;
        border-radius: 10px;
        margin-bottom: 0.29rem;
      }
      .content-text {
        .title {
          font-size: 0.31rem;
          line-height: 0.42rem;
        }
        .button {
          width: 100%;
          height: 0.88rem;
          font-size: 0.27rem;
          line-height: 0.88rem;
          margin-top: 0.38rem;
        }
      }
    }
    .content-bottom {
      border-radius: 10px;
      padding: 0.38rem 0.29rem;
      .title {
        font-size: 0.31rem;
        line-height: 0.42rem;
      }
      /deep/ p img {
        max-width: 100% !important;
        width: 100% !important;
        height: 100% !important;
      }
    }
  }
}
</style>